var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main" },
    [
      _c(
        "div",
        { staticClass: "subTitle" },
        [
          _c(
            "el-link",
            {
              attrs: {
                icon: "el-icon-arrow-left",
                underline: false,
                href: "#/pushNotification"
              }
            },
            [_vm._v("Notification Management")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "h3",
        {
          staticClass: "title",
          attrs: { content: "edit", placement: "bottom" }
        },
        [_vm._v("Edit Notification")]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "detailContent" },
        [
          _c("div", { staticClass: "requireRmarks" }, [
            _vm._v("*Required Fields")
          ]),
          _vm._v(" "),
          _c(
            "el-form",
            {
              ref: "formNotification",
              staticClass: "formNotification",
              attrs: {
                disabled:
                  _vm.formNotification.status != "REVOKED_PENDING" &&
                  _vm.formNotification.status != "REVOKED_DELIVERED"
                    ? false
                    : true,
                "label-width": "50%",
                "label-position": "left",
                model: _vm.formNotification,
                rules: _vm.formNotificationRules
              }
            },
            [
              _c("el-row", [_c("h4", [_vm._v("Notification Type")])]),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 50 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "Notification Type",
                            prop: "notificationType"
                          }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                "popper-append-to-body": false,
                                disabled: ""
                              },
                              model: {
                                value: _vm.formNotification.notificationType,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.formNotification,
                                    "notificationType",
                                    $$v
                                  )
                                },
                                expression: "formNotification.notificationType"
                              }
                            },
                            [
                              _c("el-option", {
                                attrs: {
                                  label: "System Updates",
                                  value: "SYSTEM"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: {
                                  label: "Investment Updates",
                                  value: "INVESTMENT"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: {
                                  label: "Corporate Updates",
                                  value: "CORPORATE"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: {
                                  label: "Market Updates",
                                  value: "MARKET"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "Notification category",
                            prop: "notificationCategory"
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              maxlength: "50",
                              disabled:
                                _vm.formNotification.status == "PENDING" ||
                                _vm.formNotification.status == "DELIVERED"
                                  ? false
                                  : true
                            },
                            model: {
                              value: _vm.formNotification.notificationCategory,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.formNotification,
                                  "notificationCategory",
                                  $$v
                                )
                              },
                              expression:
                                "formNotification.notificationCategory"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 50 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Important", prop: "important" } },
                        [
                          _c("el-switch", {
                            model: {
                              value: _vm.formNotification.important,
                              callback: function($$v) {
                                _vm.$set(_vm.formNotification, "important", $$v)
                              },
                              expression: "formNotification.important"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Notification ID" } },
                        [
                          _c("p", [
                            _vm._v(_vm._s(_vm.formNotification.notificationId))
                          ])
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("el-divider"),
              _vm._v(" "),
              _c("el-row", [_c("h4", [_vm._v("Client Segmentation")])]),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 50 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "Sales office", prop: "salesOffice" }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                disabled: "",
                                "popper-append-to-body": false
                              },
                              on: { change: _vm.changeSalesOffice },
                              model: {
                                value: _vm.formNotification.salesOffice,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.formNotification,
                                    "salesOffice",
                                    $$v
                                  )
                                },
                                expression: "formNotification.salesOffice"
                              }
                            },
                            _vm._l(_vm.salesOfficeList, function(item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: { label: item.name, value: item.code }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.formNotification.notificationType == "SYSTEM"
                ? _c(
                    "el-row",
                    { attrs: { gutter: 50 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "Region",
                                prop: "region",
                                "label-width": "24%"
                              }
                            },
                            [
                              _c(
                                "el-checkbox-group",
                                {
                                  attrs: {
                                    disabled:
                                      _vm.formNotification.status == "PENDING"
                                        ? false
                                        : true
                                  },
                                  model: {
                                    value: _vm.formNotification.region,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.formNotification,
                                        "region",
                                        $$v
                                      )
                                    },
                                    expression: "formNotification.region"
                                  }
                                },
                                _vm._l(_vm.regionList, function(item, index) {
                                  return _c(
                                    "el-checkbox",
                                    { key: index, attrs: { label: item.code } },
                                    [_vm._v(_vm._s(item.name))]
                                  )
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.formNotification.notificationType !== "SYSTEM"
                ? _c(
                    "el-row",
                    { attrs: { gutter: 50 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "Client / Partner (CSV file)",
                                prop: "csvFile"
                              }
                            },
                            [
                              _c(
                                "el-row",
                                {
                                  attrs: {
                                    type: "flex",
                                    justify: "space-bwteen"
                                  }
                                },
                                [
                                  _c(
                                    "el-radio",
                                    {
                                      attrs: {
                                        label: _vm.CSV_FILE_TYPE.ID_ONLY
                                      },
                                      model: {
                                        value: _vm.formNotification.csvType,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formNotification,
                                            "csvType",
                                            $$v
                                          )
                                        },
                                        expression: "formNotification.csvType"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "CSV file with Client ID & Partner ID"
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-radio",
                                    {
                                      attrs: {
                                        label: _vm.CSV_FILE_TYPE.CLIENT_PARAM
                                      },
                                      model: {
                                        value: _vm.formNotification.csvType,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formNotification,
                                            "csvType",
                                            $$v
                                          )
                                        },
                                        expression: "formNotification.csvType"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "CSV file with personalized values (Client ID only)"
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-radio",
                                    {
                                      attrs: {
                                        label: _vm.CSV_FILE_TYPE.PARTNER_PARAM
                                      },
                                      model: {
                                        value: _vm.formNotification.csvType,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formNotification,
                                            "csvType",
                                            $$v
                                          )
                                        },
                                        expression: "formNotification.csvType"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "CSV file with personalized values (Partner ID only)"
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("upload-image", {
                                ref: "UploadCSV",
                                attrs: {
                                  fileParams: _vm.CSVFileParams,
                                  fileList: _vm.CSVFileList,
                                  limit: 1,
                                  canDelete:
                                    _vm.formNotification.status == "PENDING",
                                  disabled:
                                    _vm.formNotification.status !== "PENDING"
                                },
                                on: {
                                  getSuccessRes: _vm.getCSVRes,
                                  beforeRemove: _vm.beforeRemove
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-link",
                            {
                              staticStyle: { "margin-top": "50px" },
                              attrs: {
                                icon: "el-icon-download",
                                underline: false
                              },
                              on: { click: _vm.handleDownloadTemplate }
                            },
                            [_vm._v("Download Template")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 50 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              staticStyle: { width: "100%" },
                              on: { click: _vm.handleView }
                            },
                            [_vm._v("View client / partner list")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("el-divider"),
              _vm._v(" "),
              _c("el-row", [_c("h4", [_vm._v("Title")])]),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 50 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Title (EN)", prop: "titleEn" } },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "Please enter",
                              maxlength: "200"
                            },
                            model: {
                              value: _vm.formNotification.titleEn,
                              callback: function($$v) {
                                _vm.$set(_vm.formNotification, "titleEn", $$v)
                              },
                              expression: "formNotification.titleEn"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Title (JP)", prop: "titleJp" } },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "Please enter",
                              maxlength: "200"
                            },
                            model: {
                              value: _vm.formNotification.titleJp,
                              callback: function($$v) {
                                _vm.$set(_vm.formNotification, "titleJp", $$v)
                              },
                              expression: "formNotification.titleJp"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 50 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Title (TC)", prop: "titleTc" } },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "Please enter",
                              maxlength: "200"
                            },
                            model: {
                              value: _vm.formNotification.titleTc,
                              callback: function($$v) {
                                _vm.$set(_vm.formNotification, "titleTc", $$v)
                              },
                              expression: "formNotification.titleTc"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Title (SC)", prop: "titleSc" } },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "Please enter",
                              maxlength: "200"
                            },
                            model: {
                              value: _vm.formNotification.titleSc,
                              callback: function($$v) {
                                _vm.$set(_vm.formNotification, "titleSc", $$v)
                              },
                              expression: "formNotification.titleSc"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("el-divider"),
              _vm._v(" "),
              _c("el-row", [_c("h4", [_vm._v("Notification Summary")])]),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 50 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Summary (EN)", prop: "summaryEn" } },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "Please enter",
                              maxlength: "70"
                            },
                            model: {
                              value: _vm.formNotification.summaryEn,
                              callback: function($$v) {
                                _vm.$set(_vm.formNotification, "summaryEn", $$v)
                              },
                              expression: "formNotification.summaryEn"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Summary (JP)", prop: "summaryJp" } },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "Please enter",
                              maxlength: "70"
                            },
                            model: {
                              value: _vm.formNotification.summaryJp,
                              callback: function($$v) {
                                _vm.$set(_vm.formNotification, "summaryJp", $$v)
                              },
                              expression: "formNotification.summaryJp"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 50 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Summary (TC)", prop: "summaryTc" } },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "Please enter",
                              maxlength: "70"
                            },
                            model: {
                              value: _vm.formNotification.summaryTc,
                              callback: function($$v) {
                                _vm.$set(_vm.formNotification, "summaryTc", $$v)
                              },
                              expression: "formNotification.summaryTc"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Summary (SC)", prop: "summarySc" } },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "Please enter",
                              maxlength: "70"
                            },
                            model: {
                              value: _vm.formNotification.summarySc,
                              callback: function($$v) {
                                _vm.$set(_vm.formNotification, "summarySc", $$v)
                              },
                              expression: "formNotification.summarySc"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("el-divider"),
              _vm._v(" "),
              _c(
                "el-row",
                {
                  attrs: {
                    type: "flex",
                    justify: "space-between",
                    align: "center"
                  }
                },
                [
                  _c("h4", [_vm._v("Content")]),
                  _vm._v(" "),
                  _vm.csvHasVariables
                    ? _c(
                        "el-link",
                        {
                          staticStyle: { "margin-bottom": "30px" },
                          attrs: {
                            icon: "el-icon-warning-outline",
                            underline: false
                          },
                          on: {
                            click: function($event) {
                              _vm.tagDialog = true
                            }
                          }
                        },
                        [_vm._v("How to use tags?")]
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 50 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "Content (EN)",
                            prop: "contentEn",
                            "label-width": "24%"
                          }
                        },
                        [
                          _c("quill-editor", {
                            class:
                              _vm.formNotification.status ==
                                "REVOKED_PENDING" ||
                              _vm.formNotification.status == "REVOKED_DELIVERED"
                                ? "is-disabled ql-editor"
                                : "ql-editor",
                            attrs: {
                              disabled:
                                _vm.formNotification.status ==
                                  "REVOKED_PENDING" ||
                                _vm.formNotification.status ==
                                  "REVOKED_DELIVERED"
                                  ? true
                                  : false,
                              id: "quillEn"
                            },
                            on: {
                              blur: function($event) {
                                return _vm.validContent("contentEn", "quillEn")
                              },
                              change: function($event) {
                                return _vm.validContent("contentEn")
                              }
                            },
                            model: {
                              value: _vm.formNotification.contentEn,
                              callback: function($$v) {
                                _vm.$set(_vm.formNotification, "contentEn", $$v)
                              },
                              expression: "formNotification.contentEn"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "text-align": "right",
                                "font-size": "12px",
                                color: "#909399"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$commonjs.stripHtml(
                                    _vm.formNotification.contentEn
                                  ).length
                                ) + " / 3500"
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 50 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "Content (JP)",
                            prop: "contentJp",
                            "label-width": "24%"
                          }
                        },
                        [
                          _c("quill-editor", {
                            class:
                              _vm.formNotification.status ==
                                "REVOKED_PENDING" ||
                              _vm.formNotification.status == "REVOKED_DELIVERED"
                                ? "is-disabled ql-editor"
                                : "ql-editor",
                            attrs: {
                              disabled:
                                _vm.formNotification.status ==
                                  "REVOKED_PENDING" ||
                                _vm.formNotification.status ==
                                  "REVOKED_DELIVERED"
                                  ? true
                                  : false,
                              id: "quillJp"
                            },
                            on: {
                              blur: function($event) {
                                return _vm.validContent("contentJp", "quillJp")
                              },
                              change: function($event) {
                                return _vm.validContent("contentJp")
                              }
                            },
                            model: {
                              value: _vm.formNotification.contentJp,
                              callback: function($$v) {
                                _vm.$set(_vm.formNotification, "contentJp", $$v)
                              },
                              expression: "formNotification.contentJp"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "text-align": "right",
                                "font-size": "12px",
                                color: "#909399"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$commonjs.stripHtml(
                                    _vm.formNotification.contentJp
                                  ).length
                                ) + " / 3500"
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 50 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "Content (TC)",
                            prop: "contentTc",
                            "label-width": "24%"
                          }
                        },
                        [
                          _c("quill-editor", {
                            class:
                              _vm.formNotification.status ==
                                "REVOKED_PENDING" ||
                              _vm.formNotification.status == "REVOKED_DELIVERED"
                                ? "is-disabled ql-editor"
                                : "ql-editor",
                            attrs: {
                              disabled:
                                _vm.formNotification.status ==
                                  "REVOKED_PENDING" ||
                                _vm.formNotification.status ==
                                  "REVOKED_DELIVERED"
                                  ? true
                                  : false,
                              id: "quillTc"
                            },
                            on: {
                              blur: function($event) {
                                return _vm.validContent("contentTc", "quillTc")
                              },
                              change: function($event) {
                                return _vm.validContent("contentTc")
                              }
                            },
                            model: {
                              value: _vm.formNotification.contentTc,
                              callback: function($$v) {
                                _vm.$set(_vm.formNotification, "contentTc", $$v)
                              },
                              expression: "formNotification.contentTc"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "text-align": "right",
                                "font-size": "12px",
                                color: "#909399"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$commonjs.stripHtml(
                                    _vm.formNotification.contentTc
                                  ).length
                                ) + " / 3500"
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 50 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "Content (SC)",
                            prop: "contentSc",
                            "label-width": "24%"
                          }
                        },
                        [
                          _c("quill-editor", {
                            ref: "contentSc",
                            class:
                              _vm.formNotification.status ==
                                "REVOKED_PENDING" ||
                              _vm.formNotification.status == "REVOKED_DELIVERED"
                                ? "is-disabled ql-editor"
                                : "ql-editor",
                            attrs: {
                              disabled:
                                _vm.formNotification.status ==
                                  "REVOKED_PENDING" ||
                                _vm.formNotification.status ==
                                  "REVOKED_DELIVERED"
                                  ? true
                                  : false,
                              id: "quillSc"
                            },
                            on: {
                              blur: function($event) {
                                return _vm.validContent("contentSc", "quillSc")
                              },
                              change: function($event) {
                                return _vm.validContent("contentSc")
                              }
                            },
                            model: {
                              value: _vm.formNotification.contentSc,
                              callback: function($$v) {
                                _vm.$set(_vm.formNotification, "contentSc", $$v)
                              },
                              expression: "formNotification.contentSc"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "text-align": "right",
                                "font-size": "12px",
                                color: "#909399"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$commonjs.stripHtml(
                                    _vm.formNotification.contentSc
                                  ).length
                                ) + " / 3500"
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("el-divider"),
              _vm._v(" "),
              _c("el-row", [
                _c("h4", { staticStyle: { "margin-bottom": "8px" } }, [
                  _vm._v("Images")
                ]),
                _vm._v(" "),
                _c(
                  "p",
                  { staticStyle: { "font-size": "14px", color: "#4f7a96" } },
                  [
                    _vm._v(
                      "\n          Suggeset size: 1125(W) x 630(H)\n        "
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 50 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "1 image for all languages",
                            prop: "imageIsSame4All"
                          }
                        },
                        [
                          _c("el-switch", {
                            model: {
                              value: _vm.formNotification.imageIsSame4All,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.formNotification,
                                  "imageIsSame4All",
                                  $$v
                                )
                              },
                              expression: "formNotification.imageIsSame4All"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 50 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "- English", prop: "imageEn" } },
                        [
                          _c("upload-image", {
                            ref: "UploadImageEn",
                            attrs: {
                              fileParams: _vm.imageEnFileParams,
                              fileList: _vm.imageEnFileList,
                              limit: 1,
                              accept: "image"
                            },
                            on: { getSuccessRes: _vm.getImageEnRes }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "- Japanese", prop: "imageJp" } },
                        [
                          _c("upload-image", {
                            ref: "UploadImageJp",
                            attrs: {
                              fileParams: _vm.imageJpFileParams,
                              fileList: _vm.imageJpFileList,
                              limit: 1,
                              accept: "image",
                              disabled: _vm.formNotification.imageIsSame4All
                            },
                            on: { getSuccessRes: _vm.getImageJpRes }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 50 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "- Traditional Chinese",
                            prop: "imageTc"
                          }
                        },
                        [
                          _c("upload-image", {
                            ref: "UploadImageTc",
                            attrs: {
                              fileParams: _vm.imageTcFileParams,
                              fileList: _vm.imageTcFileList,
                              limit: 1,
                              accept: "image",
                              disabled: _vm.formNotification.imageIsSame4All
                            },
                            on: { getSuccessRes: _vm.getImageTcRes }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "- Simplified Chinese",
                            prop: "imageSc"
                          }
                        },
                        [
                          _c("upload-image", {
                            ref: "UploadImageSc",
                            attrs: {
                              fileParams: _vm.imageScFileParams,
                              fileList: _vm.imageScFileList,
                              limit: 1,
                              accept: "image",
                              disabled: _vm.formNotification.imageIsSame4All
                            },
                            on: { getSuccessRes: _vm.getImageScRes }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("el-divider"),
              _vm._v(" "),
              _vm.formNotification.notificationType != "SYSTEM"
                ? _c(
                    "div",
                    [
                      _c("el-row", [_c("h4", [_vm._v("Button1")])]),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        { attrs: { gutter: 50 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "Button Type",
                                    prop: "button1Type"
                                  }
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      attrs: { placeholder: "Please select" },
                                      on: {
                                        change: function(v) {
                                          return _vm.handleButtonChecking(
                                            v,
                                            "1"
                                          )
                                        }
                                      },
                                      model: {
                                        value: _vm.formNotification.button1Type,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formNotification,
                                            "button1Type",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "formNotification.button1Type"
                                      }
                                    },
                                    [
                                      _c("el-option", {
                                        attrs: { label: "None", value: "NONE" }
                                      }),
                                      _vm._v(" "),
                                      _c("el-option", {
                                        attrs: {
                                          label: "Go to URL",
                                          value: "URL"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("el-option", {
                                        attrs: {
                                          label: "Go to Project page",
                                          value: "PROJECT"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("el-option", {
                                        attrs: {
                                          label: "Go to Investment page",
                                          value: "INVESTMENT"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.formNotification.button1Type == "PROJECT"
                            ? _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "Project ID & Name",
                                        prop: "button1IdName",
                                        rules: {
                                          required:
                                            _vm.formNotification.button1Type ==
                                            "PROJECT"
                                              ? true
                                              : false,
                                          message:
                                            "Project ID & Name cannot be empty"
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          attrs: {
                                            placeholder: "Please select",
                                            disabled:
                                              _vm.formNotification
                                                .button1Type !== "PROJECT"
                                          },
                                          model: {
                                            value:
                                              _vm.formNotification
                                                .button1IdName,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formNotification,
                                                "button1IdName",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "formNotification.button1IdName"
                                          }
                                        },
                                        _vm._l(_vm.projectList, function(
                                          item,
                                          index
                                        ) {
                                          return _c("el-option", {
                                            key: index,
                                            attrs: {
                                              label: item.name.EN
                                                ? item.name.EN +
                                                  " - (" +
                                                  item.region +
                                                  ")"
                                                : item.name.JA
                                                ? item.name.JA +
                                                  " - (" +
                                                  item.region +
                                                  ")"
                                                : item.name.ZH_HK
                                                ? item.name.ZH_HK +
                                                  " - (" +
                                                  item.region +
                                                  ")"
                                                : item.name.ZH_CN +
                                                  " - (" +
                                                  item.region +
                                                  ")",
                                              value: item.id
                                            }
                                          })
                                        }),
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.formNotification.button1Type != "NONE"
                        ? _c(
                            "el-row",
                            { attrs: { gutter: 50 } },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "Button Name (EN)",
                                        prop: "button1NameEn",
                                        rules: {
                                          required:
                                            _vm.formNotification.button1Type ==
                                            "NONE"
                                              ? false
                                              : true,
                                          message:
                                            "Button Name (EN) cannot be empty"
                                        }
                                      }
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          maxlength: "15",
                                          placeholder: "Please enter",
                                          disabled:
                                            _vm.formNotification.button1Type ==
                                            "NONE"
                                        },
                                        model: {
                                          value:
                                            _vm.formNotification.button1NameEn,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formNotification,
                                              "button1NameEn",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formNotification.button1NameEn"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "Button Name (JP)",
                                        prop: "button1NameJp",
                                        rules: {
                                          required:
                                            _vm.formNotification.button1Type ==
                                            "NONE"
                                              ? false
                                              : true,
                                          message:
                                            "Button Name (JP) cannot be empty"
                                        }
                                      }
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          maxlength: "15",
                                          placeholder: "Please enter",
                                          disabled:
                                            _vm.formNotification.button1Type ==
                                            "NONE"
                                        },
                                        model: {
                                          value:
                                            _vm.formNotification.button1NameJp,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formNotification,
                                              "button1NameJp",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formNotification.button1NameJp"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.formNotification.button1Type != "NONE"
                        ? _c(
                            "el-row",
                            { attrs: { gutter: 50 } },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "Button Name (TC)",
                                        prop: "button1NameTc",
                                        rules: {
                                          required:
                                            _vm.formNotification.button1Type ==
                                            "NONE"
                                              ? false
                                              : true,
                                          message:
                                            "Button Name (TC) cannot be empty"
                                        }
                                      }
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          maxlength: "15",
                                          placeholder: "Please enter",
                                          disabled:
                                            _vm.formNotification.button1Type ==
                                            "NONE"
                                        },
                                        model: {
                                          value:
                                            _vm.formNotification.button1NameTc,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formNotification,
                                              "button1NameTc",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formNotification.button1NameTc"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "Button Name (SC)",
                                        prop: "button1NameSc",
                                        rules: {
                                          required:
                                            _vm.formNotification.button1Type ==
                                            "NONE"
                                              ? false
                                              : true,
                                          message:
                                            "Button Name (SC) cannot be empty"
                                        }
                                      }
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          maxlength: "15",
                                          placeholder: "Please enter",
                                          disabled:
                                            _vm.formNotification.button1Type ==
                                            "NONE"
                                        },
                                        model: {
                                          value:
                                            _vm.formNotification.button1NameSc,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formNotification,
                                              "button1NameSc",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formNotification.button1NameSc"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.formNotification.button1Type == "URL"
                        ? _c(
                            "el-row",
                            { attrs: { gutter: 50 } },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "URL (EN)",
                                        prop: "button1URLEn",
                                        rules: {
                                          required:
                                            _vm.formNotification.button1Type ==
                                            "URL"
                                              ? true
                                              : false,
                                          message: "URL (EN) cannot be empty"
                                        }
                                      }
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          placeholder: "Please enter",
                                          disabled:
                                            _vm.formNotification.button1Type !==
                                            "URL"
                                        },
                                        model: {
                                          value:
                                            _vm.formNotification.button1URLEn,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formNotification,
                                              "button1URLEn",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formNotification.button1URLEn"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "URL (JP)",
                                        prop: "button1URLJp",
                                        rules: {
                                          required:
                                            _vm.formNotification.button1Type ==
                                            "URL"
                                              ? true
                                              : false,
                                          message: "URL (JP) cannot be empty"
                                        }
                                      }
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          placeholder: "Please enter",
                                          disabled:
                                            _vm.formNotification.button1Type !==
                                            "URL"
                                        },
                                        model: {
                                          value:
                                            _vm.formNotification.button1URLJp,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formNotification,
                                              "button1URLJp",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formNotification.button1URLJp"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.formNotification.button1Type == "URL"
                        ? _c(
                            "el-row",
                            { attrs: { gutter: 50 } },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "URL (TC)",
                                        prop: "button1URLTc",
                                        rules: {
                                          required:
                                            _vm.formNotification.button1Type ==
                                            "URL"
                                              ? true
                                              : false,
                                          message: "URL (TC) cannot be empty"
                                        }
                                      }
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          placeholder: "Please enter",
                                          disabled:
                                            _vm.formNotification.button1Type !==
                                            "URL"
                                        },
                                        model: {
                                          value:
                                            _vm.formNotification.button1URLTc,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formNotification,
                                              "button1URLTc",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formNotification.button1URLTc"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "URL (SC)",
                                        prop: "button1URLSc",
                                        rules: {
                                          required:
                                            _vm.formNotification.button1Type ==
                                            "URL"
                                              ? true
                                              : false,
                                          message: "URL (SC) cannot be empty"
                                        }
                                      }
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          placeholder: "Please enter",
                                          disabled:
                                            _vm.formNotification.button1Type !==
                                            "URL"
                                        },
                                        model: {
                                          value:
                                            _vm.formNotification.button1URLSc,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formNotification,
                                              "button1URLSc",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formNotification.button1URLSc"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("el-divider"),
                      _vm._v(" "),
                      _c("el-row", [_c("h4", [_vm._v("Button2")])]),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        { attrs: { gutter: 50 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "Button Type",
                                    prop: "button2Type"
                                  }
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      attrs: {
                                        disabled:
                                          _vm.formNotification.button1Type ==
                                          "NONE",
                                        placeholder: "Please select"
                                      },
                                      on: {
                                        change: function(v) {
                                          return _vm.handleButtonChecking(
                                            v,
                                            "2"
                                          )
                                        }
                                      },
                                      model: {
                                        value: _vm.formNotification.button2Type,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formNotification,
                                            "button2Type",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "formNotification.button2Type"
                                      }
                                    },
                                    [
                                      _c("el-option", {
                                        attrs: { label: "None", value: "NONE" }
                                      }),
                                      _vm._v(" "),
                                      _c("el-option", {
                                        attrs: {
                                          label: "Go to URL",
                                          value: "URL"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("el-option", {
                                        attrs: {
                                          label: "Go to Project page",
                                          value: "PROJECT"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("el-option", {
                                        attrs: {
                                          label: "Go to Investment page",
                                          value: "INVESTMENT"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.formNotification.button2Type == "PROJECT"
                            ? _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "Project ID & Name",
                                        prop: "button2IdName",
                                        rules: {
                                          required:
                                            _vm.formNotification.button2Type ==
                                            "PROJECT"
                                              ? true
                                              : false,
                                          message:
                                            "Project ID & Name cannot be empty"
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          attrs: {
                                            placeholder: "Please select",
                                            disabled:
                                              _vm.formNotification
                                                .button2Type !== "PROJECT"
                                          },
                                          model: {
                                            value:
                                              _vm.formNotification
                                                .button2IdName,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formNotification,
                                                "button2IdName",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "formNotification.button2IdName"
                                          }
                                        },
                                        _vm._l(_vm.projectList, function(
                                          item,
                                          index
                                        ) {
                                          return _c("el-option", {
                                            key: index,
                                            attrs: {
                                              label: item.name.EN
                                                ? item.name.EN +
                                                  " - (" +
                                                  item.region +
                                                  ")"
                                                : item.name.JA
                                                ? item.name.JA +
                                                  " - (" +
                                                  item.region +
                                                  ")"
                                                : item.name.ZH_HK
                                                ? item.name.ZH_HK +
                                                  " - (" +
                                                  item.region +
                                                  ")"
                                                : item.name.ZH_CN +
                                                  " - (" +
                                                  item.region +
                                                  ")",
                                              value: item.id
                                            }
                                          })
                                        }),
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.formNotification.button2Type != "NONE"
                        ? _c(
                            "el-row",
                            { attrs: { gutter: 50 } },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "Button Name (EN)",
                                        prop: "button2NameEn",
                                        rules: {
                                          required:
                                            _vm.formNotification.button2Type ==
                                            "NONE"
                                              ? false
                                              : true,
                                          message:
                                            "Button Name (EN) cannot be empty"
                                        }
                                      }
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          maxlength: "15",
                                          placeholder: "Please enter",
                                          disabled:
                                            _vm.formNotification.button2Type ==
                                            "NONE"
                                        },
                                        model: {
                                          value:
                                            _vm.formNotification.button2NameEn,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formNotification,
                                              "button2NameEn",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formNotification.button2NameEn"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "Button Name (JP)",
                                        prop: "button2NameJp",
                                        rules: {
                                          required:
                                            _vm.formNotification.button2Type ==
                                            "NONE"
                                              ? false
                                              : true,
                                          message:
                                            "Button Name (JP) cannot be empty"
                                        }
                                      }
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          maxlength: "15",
                                          placeholder: "Please enter",
                                          disabled:
                                            _vm.formNotification.button2Type ==
                                            "NONE"
                                        },
                                        model: {
                                          value:
                                            _vm.formNotification.button2NameJp,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formNotification,
                                              "button2NameJp",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formNotification.button2NameJp"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.formNotification.button2Type != "NONE"
                        ? _c(
                            "el-row",
                            { attrs: { gutter: 50 } },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "Button Name (TC)",
                                        prop: "button2NameTc",
                                        rules: {
                                          required:
                                            _vm.formNotification.button2Type ==
                                            "NONE"
                                              ? false
                                              : true,
                                          message:
                                            "Button Name (TC) cannot be empty"
                                        }
                                      }
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          maxlength: "15",
                                          placeholder: "Please enter",
                                          disabled:
                                            _vm.formNotification.button2Type ==
                                            "NONE"
                                        },
                                        model: {
                                          value:
                                            _vm.formNotification.button2NameTc,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formNotification,
                                              "button2NameTc",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formNotification.button2NameTc"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "Button Name (SC)",
                                        prop: "button2NameSc",
                                        rules: {
                                          required:
                                            _vm.formNotification.button2Type ==
                                            "NONE"
                                              ? false
                                              : true,
                                          message:
                                            "Button Name (SC) cannot be empty"
                                        }
                                      }
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          maxlength: "15",
                                          placeholder: "Please enter",
                                          disabled:
                                            _vm.formNotification.button2Type ==
                                            "NONE"
                                        },
                                        model: {
                                          value:
                                            _vm.formNotification.button2NameSc,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formNotification,
                                              "button2NameSc",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formNotification.button2NameSc"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.formNotification.button2Type == "URL"
                        ? _c(
                            "el-row",
                            { attrs: { gutter: 50 } },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "URL (EN)",
                                        prop: "button2URLEn",
                                        rules: {
                                          required:
                                            _vm.formNotification.button2Type ==
                                            "URL"
                                              ? true
                                              : false,
                                          message: "URL (EN) cannot be empty"
                                        }
                                      }
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          placeholder: "Please enter",
                                          disabled:
                                            _vm.formNotification.button2Type !==
                                            "URL"
                                        },
                                        model: {
                                          value:
                                            _vm.formNotification.button2URLEn,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formNotification,
                                              "button2URLEn",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formNotification.button2URLEn"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "URL (JP)",
                                        prop: "button2URLJp",
                                        rules: {
                                          required:
                                            _vm.formNotification.button2Type ==
                                            "URL"
                                              ? true
                                              : false,
                                          message: "URL (JP) cannot be empty"
                                        }
                                      }
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          placeholder: "Please enter",
                                          disabled:
                                            _vm.formNotification.button2Type !==
                                            "URL"
                                        },
                                        model: {
                                          value:
                                            _vm.formNotification.button2URLJp,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formNotification,
                                              "button2URLJp",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formNotification.button2URLJp"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.formNotification.button2Type == "URL"
                        ? _c(
                            "el-row",
                            { attrs: { gutter: 50 } },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "URL (TC)",
                                        prop: "button2URLTc",
                                        rules: {
                                          required:
                                            _vm.formNotification.button2Type ==
                                            "URL"
                                              ? true
                                              : false,
                                          message: "URL (TC) cannot be empty"
                                        }
                                      }
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          placeholder: "Please enter",
                                          disabled:
                                            _vm.formNotification.button2Type !==
                                            "URL"
                                        },
                                        model: {
                                          value:
                                            _vm.formNotification.button2URLTc,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formNotification,
                                              "button2URLTc",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formNotification.button2URLTc"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "URL (SC)",
                                        prop: "button2URLSc",
                                        rules: {
                                          required:
                                            _vm.formNotification.button2Type ==
                                            "URL"
                                              ? true
                                              : false,
                                          message: "URL (SC) cannot be empty"
                                        }
                                      }
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          placeholder: "Please enter",
                                          disabled:
                                            _vm.formNotification.button2Type !==
                                            "URL"
                                        },
                                        model: {
                                          value:
                                            _vm.formNotification.button2URLSc,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formNotification,
                                              "button2URLSc",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formNotification.button2URLSc"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("el-divider")
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("el-row", [_c("h4", [_vm._v("Delivery & Status")])]),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 50 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "Delivery Date & Time (UTC+8)",
                            prop: "deliveryDate"
                          }
                        },
                        [
                          _c(
                            "el-row",
                            {
                              staticStyle: { "margin-bottom": "0" },
                              attrs: {
                                gutter: 10,
                                justify: "space-between",
                                type: "flex"
                              }
                            },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { prop: "deliveryD" } },
                                    [
                                      _c("el-date-picker", {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          disabled: "",
                                          type: "date",
                                          "range-separator": "/",
                                          format: "yyyy/MM/dd",
                                          "value-format": "yyyy/MM/dd",
                                          placeholder: "Date"
                                        },
                                        on: { change: _vm.handleDeliveryDate },
                                        model: {
                                          value: _vm.formNotification.deliveryD,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formNotification,
                                              "deliveryD",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formNotification.deliveryD"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { prop: "deliveryT" } },
                                    [
                                      _c("el-time-select", {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          disabled: "",
                                          "picker-options": {
                                            start: "00:00",
                                            step: "00:15",
                                            end: "24:00"
                                          },
                                          placeholder: "Time"
                                        },
                                        on: { change: _vm.handleDeliveryDate },
                                        model: {
                                          value: _vm.formNotification.deliveryT,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formNotification,
                                              "deliveryT",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formNotification.deliveryT"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 50 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Status", prop: "status" } },
                        [
                          _c("p", [
                            _vm._v(
                              _vm._s(
                                _vm.$commonjs.pushStatusMap(
                                  _vm.formNotification.status
                                )
                              )
                            )
                          ])
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "Last update by", prop: "updateBy" }
                        },
                        [
                          _c("p", [
                            _vm._v(_vm._s(_vm.formNotification.updateBy))
                          ])
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        {
          staticStyle: { padding: "25px 0" },
          attrs: { type: "flex", justify: "end", gutter: 20 }
        },
        [
          _vm.formNotification.status != "REVOKED_PENDING" &&
          _vm.formNotification.status != "REVOKED_DELIVERED"
            ? _c(
                "el-col",
                { attrs: { span: 4 } },
                [
                  _vm.showSave
                    ? _c(
                        "el-button",
                        {
                          staticClass: "reset",
                          staticStyle: { width: "100%" },
                          on: { click: _vm.handleCancel }
                        },
                        [_vm._v("Cancel")]
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.formNotification.status != "REVOKED_PENDING" &&
          _vm.formNotification.status != "REVOKED_DELIVERED"
            ? _c(
                "el-col",
                { attrs: { span: 4 } },
                [
                  _vm.showSave
                    ? _c(
                        "el-button",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { type: "primary" },
                          on: { click: _vm.handleSave }
                        },
                        [_vm._v("Save")]
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Client / Partner List",
            visible: _vm.viewDialog,
            width: "1300px"
          },
          on: {
            "update:visible": function($event) {
              _vm.viewDialog = $event
            }
          }
        },
        [
          _vm.formNotification.notificationType !== "SYSTEM"
            ? _c(
                "div",
                { staticClass: "clientListFilter" },
                [
                  _c(
                    "div",
                    [
                      _c("span", [
                        _vm._v("Total in CSV file:" + _vm._s(_vm.clientTotal))
                      ]),
                      _vm._v(" "),
                      _c("el-divider", { attrs: { direction: "vertical" } }),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v("HK Sales office:" + _vm._s(_vm.hkTotal))
                      ]),
                      _vm._v(" "),
                      _c("el-divider", { attrs: { direction: "vertical" } }),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v("SG Sales office:" + _vm._s(_vm.sgTotal))
                      ]),
                      _vm._v(" "),
                      _c("el-divider", { attrs: { direction: "vertical" } }),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v("Ignored:" + _vm._s(_vm.csvIgnoreTotal))
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { icon: "el-icon-refresh", type: "primary" },
                      on: { click: _vm.refreshClientList }
                    },
                    [_vm._v("Refresh Data")]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-form",
            {
              ref: "formFilter",
              staticClass: "demo-form-inline",
              staticStyle: { "text-align": "left" },
              attrs: {
                "label-position": "top",
                model: _vm.formFilter,
                inline: true
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { prop: "clientId" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "150px" },
                    attrs: { placeholder: "Client / Partner ID" },
                    model: {
                      value: _vm.formFilter.clientId,
                      callback: function($$v) {
                        _vm.$set(_vm.formFilter, "clientId", $$v)
                      },
                      expression: "formFilter.clientId"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { prop: "salesOffice" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "120px" },
                      attrs: { placeholder: "Sales Office" },
                      model: {
                        value: _vm.formFilter.salesOffice,
                        callback: function($$v) {
                          _vm.$set(_vm.formFilter, "salesOffice", $$v)
                        },
                        expression: "formFilter.salesOffice"
                      }
                    },
                    _vm._l(_vm.salesOfficeList, function(item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { value: item.code, label: item.name }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { prop: "region" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "120px" },
                      attrs: { placeholder: "Region" },
                      model: {
                        value: _vm.formFilter.region,
                        callback: function($$v) {
                          _vm.$set(_vm.formFilter, "region", $$v)
                        },
                        expression: "formFilter.region"
                      }
                    },
                    _vm._l(_vm.regionList, function(item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { value: item.code, label: item.name }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { prop: "userStatus" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "120px" },
                      attrs: { placeholder: "User Status" },
                      model: {
                        value: _vm.formFilter.userStatus,
                        callback: function($$v) {
                          _vm.$set(_vm.formFilter, "userStatus", $$v)
                        },
                        expression: "formFilter.userStatus"
                      }
                    },
                    [
                      _c("el-option", {
                        attrs: { value: "OPENED", label: "Inactive" }
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { value: "ACTIVATED", label: "Active" }
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { value: "SUSPENDED", label: "Suspended" }
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { value: "DELETED", label: "Deleted" }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { prop: "inboxStatus" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "130px" },
                      attrs: { placeholder: "Inbox Status" },
                      model: {
                        value: _vm.formFilter.inboxStatus,
                        callback: function($$v) {
                          _vm.$set(_vm.formFilter, "inboxStatus", $$v)
                        },
                        expression: "formFilter.inboxStatus"
                      }
                    },
                    [
                      _c("el-option", {
                        attrs: { value: "RECEIVED", label: "Received" }
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { value: "PENDING", label: "Pending" }
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { value: "IGNORED", label: "Ignored" }
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { value: "FAILED", label: "Failed" }
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { value: "DELETED", label: "Deleted" }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { prop: "pushStatus" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "120px" },
                      attrs: { placeholder: "Push Status" },
                      model: {
                        value: _vm.formFilter.pushStatus,
                        callback: function($$v) {
                          _vm.$set(_vm.formFilter, "pushStatus", $$v)
                        },
                        expression: "formFilter.pushStatus"
                      }
                    },
                    [
                      _c("el-option", {
                        attrs: { value: "RECEIVED", label: "Received" }
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { value: "PENDING", label: "Pending" }
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { value: "IGNORED", label: "Ignored" }
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { value: "FAILED", label: "Failed" }
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { value: "DELETED", label: "Deleted" }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    { staticClass: "search", on: { click: _vm.submitApply } },
                    [_vm._v("Apply")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "reset",
                      on: {
                        click: function($event) {
                          return _vm.resetForm("formFilter")
                        }
                      }
                    },
                    [_vm._v("Reset")]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            { attrs: { data: _vm.tableData, "max-height": "500px" } },
            [
              _c("el-table-column", {
                attrs: { prop: "sfUserType", label: "User Type", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          _vm._s(
                            _vm.$commonjs.sfUserIdTypeMap(scope.row.sfUserType)
                          )
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Record Type" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          _vm._s(
                            scope.row.salesforceRecordType.hasOwnProperty(
                              "name"
                            )
                              ? scope.row.salesforceRecordType.name
                              : "-"
                          )
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "clientId", label: "ID", width: "70" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "username", label: "User Name" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "SF Full Name" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          _vm._s(
                            _vm.$commonjs.formatDisplayName(scope.row, "-")
                          )
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "email", label: "Email" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(_vm._s(scope.row.email ? scope.row.email : "-"))
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "salesOffice", label: "Sales office" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          _vm._s(
                            _vm.$commonjs.salesOfficeMap(scope.row.salesOffice)
                          )
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "region", label: "Region" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          _vm._s(_vm.$commonjs.regionMap(scope.row.region))
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "userStatus", label: "User Status" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          _vm._s(
                            _vm.$commonjs.userStatusMap(scope.row.userStatus)
                          )
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "inboxStatus", label: "Inbox Status" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          _vm._s(
                            _vm.$commonjs.inboxStatusMap(scope.row.inboxStatus)
                          )
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "pushStatus", label: "Push Status" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          _vm._s(
                            _vm.$commonjs.inboxStatusMap(scope.row.pushStatus)
                          )
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("app-pagination", {
            attrs: {
              "current-page": _vm.currentPage,
              "page-sizes": [5, 10, 20, 50],
              total: _vm.total,
              "page-size": _vm.currentSize
            },
            on: {
              "size-change": function(v) {
                _vm.currentSize = v
                _vm.currentPage = 1
                _vm.getClientList()
              },
              "current-change": function(v) {
                _vm.currentPage = v
                _vm.getClientList()
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.tagDialog,
            width: "500px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.tagDialog = $event
            }
          }
        },
        [
          _c(
            "p",
            {
              staticStyle: {
                color: "#003448",
                "font-weight": "600",
                "font-size": "20px"
              },
              attrs: { slot: "title" },
              slot: "title"
            },
            [_vm._v("\n      How to use tags?\n    ")]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticStyle: {
                "text-align": "left",
                "font-size": "16px",
                color: "#003448"
              }
            },
            [
              _c("p", { staticStyle: { "margin-bottom": "15px" } }, [
                _vm._v(
                  "\n        Insert the tag into the sentence. For example:\n      "
                )
              ]),
              _vm._v(" "),
              _c("p", { staticStyle: { "line-height": "22px" } }, [
                _vm._v("The value of <AMT1> is 1000")
              ]),
              _vm._v(" "),
              _c("p", { staticStyle: { "line-height": "22px" } }, [
                _vm._v("The value of <AMT2> is 2000")
              ]),
              _vm._v(" "),
              _c("p", { staticStyle: { "line-height": "22px" } }, [
                _vm._v("The value of <AMT3> is 3000")
              ]),
              _vm._v(" "),
              _c("p", { staticStyle: { "line-height": "22px" } }, [
                _vm._v("The value of <AMT4> is 4000")
              ]),
              _vm._v(" "),
              _c(
                "strong",
                { staticStyle: { display: "block", margin: "10px 0" } },
                [_vm._v("Type:")]
              ),
              _vm._v(" "),
              _c(
                "el-card",
                {
                  staticClass: "box-card",
                  attrs: {
                    shadow: "always",
                    "body-style": {
                      fontSize: "14px",
                      lineHeight: "20px",
                      wordBreak: "break-word",
                      background: "#f5f7fa"
                    }
                  }
                },
                [
                  _c("p", { staticStyle: { "margin-bottom": "15px" } }, [
                    _vm._v(
                      "\n          Walton LAD Verano Breakdown (18/08/2020)\n        "
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "\n          $<AMT1> is remitted from Walton International Group Limited\n          (Account Number:808 249XXX 274) to your designated account.\n        "
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", [_vm._v("Principal Repayment: $<AMT2>")]),
                  _vm._v(" "),
                  _c("p", { staticStyle: { "margin-bottom": "15px" } }, [
                    _vm._v("Interest: $<AMT3>")
                  ]),
                  _vm._v(" "),
                  _c("p", [_vm._v("Outstanding Balance: $<AMT4>")])
                ]
              ),
              _vm._v(" "),
              _c(
                "strong",
                { staticStyle: { display: "block", margin: "10px 0" } },
                [_vm._v("Output:")]
              ),
              _vm._v(" "),
              _c(
                "el-card",
                {
                  staticClass: "box-card",
                  attrs: {
                    shadow: "always",
                    "body-style": {
                      fontSize: "14px",
                      lineHeight: "20px",
                      wordBreak: "break-word",
                      background: "#f5f7fa"
                    }
                  }
                },
                [
                  _c("p", { staticStyle: { "margin-bottom": "15px" } }, [
                    _vm._v(
                      "\n          Walton LAD Verano Breakdown (18/08/2020)\n        "
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "\n          $1000 is remitted from Walton International Group Limited (Account\n          Number:808 249XXX 274) to your designated account.\n        "
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", [_vm._v("Principal Repayment: $2000")]),
                  _vm._v(" "),
                  _c("p", { staticStyle: { "margin-bottom": "15px" } }, [
                    _vm._v("Interest: $3000")
                  ]),
                  _vm._v(" "),
                  _c("p", [_vm._v("Outstanding Balance: $4000")])
                ]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-624c0859", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-624c0859","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/notification/editNotification.vue
// module id = null
// module chunks = 